import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SideNavService {
  private readonly _isOpen = new BehaviorSubject<boolean>(false);

  isOpen$ = this._isOpen.asObservable();

 openSidenav() {
   this._isOpen.next(true);
  }

 closeSidenav() {
   this._isOpen.next(false);
  }  
}
